<!-- Sign-up Form -->
<ng-container *ngIf="showSignUpScreen">
    <div class="ppLogin_content">
        <div class="ppLogin_body">
            <form [formGroup]="registrationForm" (ngSubmit)="sendOtp()">
                <div class="loginBody-content">
                    <h1 class="loginTitle">{{ 'MODULES.LOGIN.SIGNIN_HEADER' | transloco }}</h1>
                    <h2 class="loginHeader">{{ 'MODULES.LOGIN.SIGNUP_SUBHEADER' | transloco }}</h2>
                    <div class="dsFieldWrap dsFieldError">
                        <div class="dsLabel">{{ 'MODULES.LOGIN.EMAIL_ADDRESS' | transloco }}<sup
                                class="dsAsterix">*</sup></div>
                        <mat-form-field appearance="outline" floatLabel="never"
                            [ngClass]="{ 'dsFieldError': registrationForm.get('email')?.invalid && (registrationForm.get('email')?.dirty || registrationForm.get('email')?.touched) }">
                            <input formControlName="email" matInput type="text" required maxlength="100" />
                        </mat-form-field>
                        <div class="dsErrorMsg"
                            *ngIf="registrationForm.get('email')?.invalid && (registrationForm.get('email')?.dirty || registrationForm.get('email')?.touched)">
                            <span *ngIf="registrationForm.get('email')?.errors?.['required']">{{
                                'MODULES.LOGIN.EMAIL_FIELD_EMPTY' | transloco }}</span>
                            <span *ngIf="registrationForm.get('email')?.hasError('email')">{{
                                'MODULES.LOGIN.INVALID_EMAIL'
                                | transloco }}</span>
                            <span
                                *ngIf="registrationForm.get('email')?.hasError('pattern') || email.hasError('domainInvalid')">{{
                                'MODULES.LOGIN.INVALID_EMAIL' | transloco }}</span>
                        </div>
                    </div>

                    <div class="dsFieldWrap">
                        <div class="dsLabel">{{ 'MODULES.LOGIN.PASSWORD' | transloco }}<sup class="dsAsterix">*</sup>
                        </div>
                        <mat-form-field appearance="outline" floatLabel="never"
                            [ngClass]="{ 'dsFieldError': password.invalid && (password.dirty || password.touched) }">
                            <input [type]="showPassword ? 'text' : 'password'" formControlName="password" matInput
                                required />
                            <span (click)="showPassword = !showPassword" class="eye loginIcon"
                                [ngClass]="{ 'icon-pswdHide': !showPassword, 'icon-pswdShow': showPassword }"></span>
                        </mat-form-field>
                        <div class="dsErrorMsg pt-3"
                            *ngIf="registrationForm.get('password')?.invalid && (registrationForm.get('password')?.dirty || registrationForm.get('password')?.touched)">
                            <span *ngIf="registrationForm.get('password')?.errors?.['required']">{{
                                'MODULES.LOGIN.PASSWORD_FIELD_EMPTY' | transloco }}</span>
                            <span
                                *ngIf="registrationForm.get('password')?.errors?.['minlength'] && !registrationForm.get('password')?.errors?.['pattern']">{{
                                'MODULES.LOGIN.LOGIN_FORM_REGISTER' | transloco }}</span>
                            <span class="pt-2"
                                *ngIf="registrationForm.get('password')?.errors?.['passwordStrength'] && !registrationForm.get('password')?.errors?.['minlength'] && !registrationForm.get('password')?.errors?.['pattern']">
                                {{ 'MODULES.LOGIN.LOGIN_FORM_PASWORD' | transloco }}
                            </span>
                            <span class="pt-3" *ngIf="registrationForm.get('password')?.errors?.['pattern']">
                                {{ 'MODULES.LOGIN.NO_SPACES_ALLOWED' | transloco }}
                            </span>
                        </div>
                    </div>

                    <div class="dsFieldWrap">
                        <div class="dsLabel">{{ 'MODULES.LOGIN.CONFIRM_PASSWORD' | transloco }}<sup
                                class="dsAsterix">*</sup></div>
                        <mat-form-field appearance="outline" floatLabel="never"
                            [ngClass]="{ 'dsFieldError': confirmPassword.invalid && (confirmPassword.dirty || confirmPassword.touched) }">
                            <input [type]="showConfirmPassword ? 'text' : 'password'" formControlName="confirmPassword"
                                matInput required />
                            <span (click)="showConfirmPassword = !showConfirmPassword" class="eye loginIcon"
                                [ngClass]="{ 'icon-pswdHide': !showConfirmPassword, 'icon-pswdShow': showConfirmPassword }"></span>
                        </mat-form-field>
                        <div class="dsErrorMsg"
                            *ngIf="(registrationForm.get('confirmPassword')?.invalid && (registrationForm.get('confirmPassword')?.dirty || registrationForm.get('confirmPassword')?.touched) || registrationForm?.errors?.['mismatch'])">
                            <span
                                *ngIf="registrationForm.get('confirmPassword')?.errors?.['required'] && !registrationForm?.errors?.['mismatch']">{{
                                'MODULES.LOGIN.CONFIRMPASSWORD_FIELD_EMPTY' | transloco }}</span>
                            <span *ngIf="registrationForm?.errors?.['mismatch']">{{ 'MODULES.LOGIN.LOGIN_FORM_CONFIRM' |
                                transloco
                                }}</span>
                        </div>
                    </div>

                </div>

                <footer class="loginBody-footer">
                    <button type="submit" class="loginAction_btn">
                        {{ 'MODULES.LOGIN.CREATE' | transloco }}
                    </button>
                    <div class="login-options">
                        <div class="login-options-separator">{{ 'MODULES.LOGIN.OR' | transloco }}</div>
                        <div class="login-options-link">
                            <span>{{ 'MODULES.LOGIN.ALREADY_HAVE_LOGIN_AND_PASSWORD' | transloco }}</span>
                            <a class="dsLink" (click)="signin()"><span class="dsLink_line">{{ 'MODULES.LOGIN.SIGN_IN' |
                                    transloco
                                    }}</span></a>
                        </div>
                    </div>
                </footer>
            </form>
        </div>
        <div class="login-copyright">
            {{'MODULES.LOGIN.COPYRIGHT' | transloco }}
        </div>
    </div>
</ng-container>
<!-- OTP Verification -->
<ng-container *ngIf="showOTPScreen">
    <div class="ppLogin_content">
        <div class="ppLogin_header">
            <i class="icon-backarrow" (click)="logOut()"></i>
            {{ 'HOME.REGISTRATION' | transloco }}
        </div>
        <div class="ppLogin_body">
            <form [formGroup]="otpForm" (ngSubmit)="verifyOtpSignUp()">
                <div class="loginBody-content">
                    <h1 class="loginTitle">{{ 'MODULES.LOGIN.SIGNIN_HEADER' | transloco }}</h1>
                    <h2 class="loginHeader">{{ 'MODULES.LOGIN.OTP_VERIFICATION' | transloco }}</h2>
                    <div class="vjLoggedIn">
                        <div class="vjLoggedIn_profile">
                            <figure class="dsProfile">
                                <img src="../../../resources/images/login/host.svg" alt="">
                            </figure>
                            <div>
                                <p>{{ 'MODULES.LOGIN.SIGNED_UP_FOR' | transloco }}</p>
                                <h6 class="vjLoggedIn_profile_name" *ngIf="emailAddress">{{ maskedEmailAddress }}</h6>
                                <h6 class="vjLoggedIn_profile_name" *ngIf="!emailAddress && emailEntered">{{
                                    maskedEmailEntered }}
                                </h6>
                            </div>
                        </div>
                        <div class="vjLoggedIn_signout">
                            <p>{{ 'MODULES.LOGIN.NOT_YOU' | transloco }} <a class="dsLink" (click)="logOut()"><span
                                        class="dsLink_line">{{
                                        'MODULES.LOGIN.SIGN_OUT' | transloco }}</span></a></p>
                        </div>
                    </div>
                    <div class="vjOTPVerfication">
                        <!-- <h4>{{ 'MODULES.LOGIN.OTP_VERIFICATION' | transloco }}</h4> -->
                        <p>{{ 'MODULES.LOGIN.OTP_SENT_TO_EMAIL' | transloco }}</p>
                        <p class="vjOTPVerfication_mail"><b>{{ emailShow }}</b></p>
                        <div class="vjOTPVerfication_otp">
                            <div class="dsFieldWrap">
                                <mat-form-field><input matInput maxlength="1" formControlName="otp1" #otp1
                                        (keyup)="moveToNext($event, otp2, otp1)" /></mat-form-field>
                                <mat-form-field><input matInput maxlength="1" formControlName="otp2" #otp2
                                        (keyup)="moveToNext($event, otp3, otp1)" /></mat-form-field>
                                <mat-form-field><input matInput maxlength="1" formControlName="otp3" #otp3
                                        (keyup)="moveToNext($event, otp4, otp2)" /></mat-form-field>
                                <mat-form-field><input matInput maxlength="1" formControlName="otp4" #otp4
                                        (keyup)="moveToNext($event, otp5, otp3)" /></mat-form-field>
                                <mat-form-field><input matInput maxlength="1" formControlName="otp5" #otp5
                                        (keyup)="moveToNext($event, otp6, otp4)" /></mat-form-field>
                                <mat-form-field><input matInput maxlength="1" formControlName="otp6" #otp6
                                        (keyup)="moveToNext($event, otp6, otp5)" /></mat-form-field>
                            </div>

                        </div>
                    </div>
                </div>

                <footer class="loginBody-footer">
                    <ng-container *ngIf="!isCasinoAccVerfication">
                        <button type="submit" class="loginAction_btn">
                            {{ 'MODULES.LOGIN.OTP_CONFIRM' | transloco }}
                        </button>
                        <div class="login-options">
                            <div class="login-options-link">
                                <span>{{ 'MODULES.LOGIN.DIDNT_RECEIVE_CODE' | transloco }}</span>
                                <a class="dsLink" (click)="resendOtp()"><span class="dsLink_line">{{
                                        'MODULES.LOGIN.RESEND' |
                                        transloco
                                        }}</span></a>
                            </div>
                        </div>
                    </ng-container>

                </footer>
            </form>
        </div>
        <div class="login-copyright">
            {{'MODULES.LOGIN.COPYRIGHT' | transloco }}
        </div>
    </div>
</ng-container>

<!-- MFA Setup: Selection Screen -->
<ng-container
    *ngIf="showMfaSetupScreen && !showMfaMobileScreen && !showMfaMobileOTPScreen && !showMfaAuthenticatorScreen">
    <div class="ppLogin_content">
        <div class="ppLogin_body">
            <div class="loginBody-content">
                <h1 class="loginTitle">{{ 'MODULES.LOGIN.SIGNIN_HEADER' | transloco }}</h1>
                <h2 class="loginHeader">{{ 'MODULES.ACCOUNT_SECURITY.MFA.SUB_HEADING' | transloco }}</h2>
                <h5 class="loginHeader forgot-password-info">{{ 'MODULES.ACCOUNT_SECURITY.MFA.REGISTER_SUB_DESCRIPTION'
                    | transloco }}</h5>
            </div>
            <footer class="loginBody-footer">
                <button class="loginAction_btn" (click)="mfaStartMobileSetup()">
                    {{ 'MODULES.ACCOUNT_SECURITY.MFA.MOBILE' | transloco }}
                </button>
                <button class="loginAction_btn" (click)="mfaStartAuthenticatorSetup()">
                    {{ 'MODULES.ACCOUNT_SECURITY.MFA.AUTHENTICATOR_APP' | transloco }}
                </button>
                <div class="login-options">
                    <div class="login-options-link">
                        <a class="dsLink" (click)="mfaSkip()">
                            <span class="dsLink_line">{{ 'MODULES.LOGIN.SKIP' | transloco }}</span>
                        </a>
                    </div>
                </div>
            </footer>
        </div>
        <div class="login-copyright">{{'MODULES.LOGIN.COPYRIGHT' | transloco }}</div>
    </div>
</ng-container>

<!-- MFA Setup: Mobile Number Screen -->
<ng-container *ngIf="showMfaSetupScreen && showMfaMobileScreen && !showMfaMobileOTPScreen">
    <div class="ppLogin_content">
        <h1 class="ppLogin_header verify-gap">
            <i class="icon-backarrow" (click)="mfaCancelMobileBack()"></i>
            {{ 'MODULES.ACCOUNT_SECURITY.MFA.VERIFY' | transloco }}
        </h1>
        <div class="ppLogin_body">
            <form [formGroup]="mfaMobileForm" (ngSubmit)="mfaSubmitMobile()">
                <div class="loginBody-content">
                    <h2 class="loginHeader">{{ 'MODULES.ACCOUNT_SECURITY.MFA.SUB_HEADING_ONE' | transloco }}</h2>
                    <h5 class="loginHeader forgot-password-info">{{ 'MODULES.ACCOUNT_SECURITY.MFA.SUB_DESCRIPTION_ONE' |
                        transloco }}</h5>
                    <div class="dsFieldWrap">
                        <div class="dsLabel">{{ 'MODULES.ACCOUNT_SECURITY.MFA.COUNTRY_CODE' | transloco }}<sup
                                class="dsAsterix">*</sup></div>
                        <mat-form-field appearance="outline" floatLabel="never">
                            <mat-select formControlName="countryCode">
                                <mat-option *ngFor="let country of countries" [value]="country.dial_code">
                                    <div class="countryOption">
                                        <img class="countryFlag"
                                            [src]="'resources/images/flags/' + country.code.toLowerCase() + '.png'"
                                            [alt]="country.name">
                                        <span>{{ country.name }} ({{ country.dial_code }})</span>
                                    </div>
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <div class="dsErrorMsg"
                            *ngIf="mfaMobileForm.get('countryCode')?.touched && mfaMobileForm.get('countryCode')?.hasError('required')">
                            {{ 'MODULES.ACCOUNT_SECURITY.MFA.COUNTRY_CODE_REQUIRED' | transloco }}
                        </div>
                    </div>
                    <div class="dsFieldWrap">
                        <div class="dsLabel">{{ 'MODULES.ACCOUNT_SECURITY.MFA.MOBILE_NUMBER' | transloco }}<sup
                                class="dsAsterix">*</sup></div>
                        <mat-form-field appearance="outline" floatLabel="never">
                            <input matInput type="text" formControlName="mobileNumber" maxlength="10" />
                        </mat-form-field>
                        <div class="dsErrorMsg"
                            *ngIf="mfaMobileForm.get('mobileNumber')?.touched && mfaMobileForm.get('mobileNumber')?.hasError('required')">
                            {{ 'MODULES.ACCOUNT_SECURITY.MFA.MOBILE_REQUIRED' | transloco }}
                        </div>
                        <div class="dsErrorMsg"
                            *ngIf="mfaMobileForm.get('mobileNumber')?.touched &&
                            !mfaMobileForm.get('mobileNumber')?.hasError('required') &&
                            mfaMobileForm.get('mobileNumber')?.hasError('pattern')">
                            {{ 'MODULES.ACCOUNT_SECURITY.MFA.MOBILE_INVALID' | transloco }}
                        </div>
                        <div class="dsErrorMsg"
                            *ngIf="mfaMobileForm.get('mobileNumber')?.touched &&
                            !mfaMobileForm.get('mobileNumber')?.hasError('required') &&
                            !mfaMobileForm.get('mobileNumber')?.hasError('pattern') &&
                            (mfaMobileForm.get('mobileNumber')?.hasError('minlength') ||
                            mfaMobileForm.get('mobileNumber')?.hasError('maxlength'))">
                            {{ 'ERROR.MOBILE_LENGTH_VALIDATION' | transloco }}
                        </div>
                    </div>
                </div>
                <footer class="loginBody-footer">
                    <button type="submit" class="loginAction_btn">
                        {{ 'MODULES.ACCOUNT_SECURITY.MFA.VERIFY_OTP' | transloco }}
                    </button>
                </footer>
            </form>
        </div>
        <div class="login-copyright">{{'MODULES.LOGIN.COPYRIGHT' | transloco }}</div>
    </div>
</ng-container>

<!-- MFA Setup: Mobile OTP Verification Screen -->
<ng-container *ngIf="showMfaSetupScreen && showMfaMobileOTPScreen">
    <div class="ppLogin_content">
        <div class="ppLogin_header verify-gap">
            <i class="icon-backarrow" (click)="mfaCancelMobileOTPBack()"></i>
            {{ 'MODULES.ACCOUNT_SECURITY.MFA.VERIFY' | transloco }}
        </div>
        <div class="ppLogin_body">
            <form [formGroup]="mfaOtpForm" (ngSubmit)="mfaSubmitMobileOTP()">
                <div class="loginBody-content">
                    <h2 class="loginHeader">{{ 'MODULES.ACCOUNT_SECURITY.MFA.SUB_HEADING_ONE' | transloco }}</h2>
                    <p class="loginHeader forgot-password-info">{{ 'MODULES.ACCOUNT_SECURITY.MFA.SUB_DESCRIPTION_TWO' |
                        transloco }} {{
                        mfaMaskedMobileNumber }}</p>
                    <div class="dsFieldWrap">
                        <mat-form-field appearance="outline" floatLabel="never">
                            <input matInput type="text" formControlName="otp" maxlength="6"
                                placeholder="{{ 'MODULES.ACCOUNT_SECURITY.MFA.OTP_REQUIRED' | transloco }}" />
                        </mat-form-field>
                        <div class="dsErrorMsg"
                            *ngIf="mfaOtpForm.get('otp')?.touched && mfaOtpForm.get('otp')?.hasError('required')">
                            {{ 'MODULES.ACCOUNT_SECURITY.MFA.OTP_REQUIRED' | transloco }}
                        </div>
                        <div class="dsErrorMsg"
                            *ngIf="mfaOtpForm.get('otp')?.touched && !mfaOtpForm.get('otp')?.hasError('required') && mfaOtpForm.get('otp')?.hasError('pattern')">
                            {{ 'MODULES.ACCOUNT_SECURITY.MFA.OTP_INVALID' | transloco }}
                        </div>
                    </div>
                </div>
                <footer class="loginBody-footer">
                    <button type="submit" class="loginAction_btn" [disabled]="!mfaOtpForm.valid">
                        {{ 'MODULES.ACCOUNT_SECURITY.MFA.VALIDATE' | transloco }}
                    </button>
                    <div class="login-options">
                        <div class="login-options-link">
                            <a class="dsLink" (click)="mfaCancelMobileOTPBack()">
                                <span class="dsLink_line">{{ 'MODULES.ACCOUNT_SECURITY.MFA.CHANGE_NUMBER' | transloco
                                    }}</span>
                            </a>
                        </div>
                        <div class="login-options-link">
                            <span>{{ 'MODULES.LOGIN.DIDNT_RECEIVE_CODE' | transloco }}</span>
                            <a class="dsLink" (click)="mfaResendMobileOTP()"><span class="dsLink_line">{{
                                    'MODULES.LOGIN.RESEND' | transloco }}</span></a>
                        </div>
                    </div>
                </footer>
            </form>
        </div>
        <div class="login-copyright">{{'MODULES.LOGIN.COPYRIGHT' | transloco }}</div>
    </div>
</ng-container>

<!-- MFA Setup: Authenticator App (TOTP) Screen -->
<ng-container *ngIf="showMfaSetupScreen && showMfaAuthenticatorScreen">
    <div class="ppLogin_content">
        <div class="ppLogin_header verify-gap">
            <i class="icon-backarrow" (click)="mfaCancelAuthenticatorBack()"></i>
            {{ 'MODULES.ACCOUNT_SECURITY.MFA.AUTHENTICATOR_TITLE' | transloco }}
        </div>
        <div class="ppLogin_body">
            <form [formGroup]="mfaTotpForm" (ngSubmit)="mfaSubmitTOTP()">
                <div class="loginBody-content">
                    <h2 class="loginHeader">{{ 'MODULES.ACCOUNT_SECURITY.MFA.AUTHENTICATOR_SUB_HEADING' | transloco }}
                    </h2>
                    <!-- <div class="dsFieldWrap" *ngIf="mfaTotpSecret">
                        <div class="dsLabel">{{ 'MODULES.ACCOUNT_SECURITY.MFA.CANT_SCAN' | transloco }}</div>
                        <div class="mfaSecretKey">
                            <span>{{ mfaTotpSecret }}</span>
                            <i class="icon-copy" (click)="mfaCopySecret()"></i>
                        </div>
                    </div> -->


                    <!-- <div class="qrCodeSection" *ngIf="mfaTotpSecret">
                        <div class="secretKeyWrap">
                            <span class="dsLabel">{{ 'MODULES.ACCOUNT_SECURITY.MFA.CANT_SCAN' | transloco }}</span>
                            <div class="secretKeyBlock">
                                <span class="secretKeyValue">{{ mfaTotpSecret }}</span>
                                <button type="button" class="dsButton" (click)="mfaCopySecret()">
                                    Copy
                                </button>
                            </div>
                        </div>
                    </div> -->
                    <div class="dsFieldWrap">
                        <div class="dsLabel">{{ 'MODULES.ACCOUNT_SECURITY.MFA.TOTP_CODE_LABEL' | transloco }}<sup
                                class="dsAsterix">*</sup></div>
                        <mat-form-field appearance="outline" floatLabel="never">
                            <input matInput type="text" formControlName="totpCode" maxlength="6"
                                placeholder="{{ 'MODULES.ACCOUNT_SECURITY.MFA.TOTP_CODE_PLACEHOLDER' | transloco }}" />
                        </mat-form-field>
                        <div class="dsErrorMsg"
                            *ngIf="mfaTotpForm.get('totpCode')?.touched && mfaTotpForm.get('totpCode')?.hasError('required')">
                            {{ 'MODULES.ACCOUNT_SECURITY.MFA.TOTP_REQUIRED' | transloco }}
                        </div>
                        <div class="dsErrorMsg"
                            *ngIf="mfaTotpForm.get('totpCode')?.touched && !mfaTotpForm.get('totpCode')?.hasError('required') && mfaTotpForm.get('totpCode')?.hasError('pattern')">
                            {{ 'MODULES.ACCOUNT_SECURITY.MFA.TOTP_INVALID' | transloco }}
                        </div>
                    </div>
                </div>
                <footer class="loginBody-footer">
                    <button type="submit" class="loginAction_btn" [disabled]="!mfaTotpForm.valid">
                        {{ 'MODULES.ACCOUNT_SECURITY.MFA.VERIFY_OTP' | transloco }}
                    </button>
                </footer>
                <br>
                <!-- <div class="vjBodyInnerWrap"> -->
                <h2 class="subHeading forgot-password-info" style="font-weight: bold;">{{
                    'MODULES.ACCOUNT_SECURITY.MFA.INSTRUCTION_TITLE' | transloco }}</h2>
                <div class="dsForm_col">
                    <!-- <div class="dsFieldWrap mfaToggleWrap"> -->
                    <ul class="instructionList">
                        <li>
                            {{ 'MODULES.ACCOUNT_SECURITY.MFA.POINT_ONE' | transloco }}
                        </li>
                        <li>
                            {{ 'MODULES.ACCOUNT_SECURITY.MFA.POINT_TWO' | transloco }}
                        </li>
                        <li>
                            {{ 'MODULES.ACCOUNT_SECURITY.MFA.POINT_THREE' | transloco }}
                        </li>
                        <li>
                            {{ 'MODULES.ACCOUNT_SECURITY.MFA.POINT_FOUR' | transloco }}
                        </li>
                    </ul>
                    <!-- </div> -->
                </div>
                <!-- </div> -->
                <div class="qrCodeSection" *ngIf="mfaTotpSecret">
                    <div class="secretKeyWrap">
                        <span class="dsLabel">{{ 'MODULES.ACCOUNT_SECURITY.MFA.CANT_SCAN' | transloco }}</span>
                        <div class="secretKeyBlock">
                            <span class="secretKeyValue">{{ mfaTotpSecret }}</span>
                            <button type="button" class="dsButton" (click)="mfaCopySecret()">
                                Copy
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div class="login-copyright">{{'MODULES.LOGIN.COPYRIGHT' | transloco }}</div>
    </div>
</ng-container>